import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationService } from 'src/app/core/api-services/user-profile/registration.service';
import {
  AuthorityProfileModel,
  PersonProfileModel,
  UserProfileLookups,
} from 'src/app/core/models/user-profile/user-profile.model';
import { AuthService } from 'src/app/shared/authentication/auth.service';
import { ProfileMapper } from '../shared/profile-mapper';
import { AlertImportanceEnum } from 'src/app/shared/bs-alert/AlertImportanceEnum';
import { environment } from 'src/environments/environment';
import { BaseProfileComponent } from '../shared/base-profile.component';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-profile-registration',
  templateUrl: 'registration.component.html',
  styleUrls: ['./registration.component.scss'],
})
export class RegistrationComponent
  extends BaseProfileComponent
  implements OnInit
{
  isPerson: boolean = false;
  token: string;
  person: PersonProfileModel;
  authority: AuthorityProfileModel;
  lookups: UserProfileLookups = new UserProfileLookups();
  importance = AlertImportanceEnum;
  registrationCompleted: boolean = false;
  accountNo: string;
  requireOwners: boolean = true;
  UAEPassRedirectUrlReplacable: string = 'UAEPASSREDIRECTURL';

  constructor(
    authService: AuthService,
    private router: Router,
    private toaster: ToastrService,
    route: ActivatedRoute,
    translateService: TranslateService,
    protected _mapper: ProfileMapper,
    private _service: RegistrationService
  ) {
    super(translateService, _mapper);
    if (authService.isAuthenticated()) {
      router.navigate(['home']);
    }
    route.queryParams.subscribe((params) => {
      this.token = params['token'];
      this.isPerson = params['type'] == '1';
    });
  }

  ngOnInit(): void {
    if (this.token) {
      if (this.isPerson) {
        this._service.GetPersonToRegister(this.token).subscribe((response) => {
          if (response) {
            this.person = response.Person;
            this.person.IsVerified = true;
            this.person.Nationality = this._mapper.mapLookupItem(
              this.person.Nationality
            );
            this.person.ResidencyType = this._mapper.mapLookupItem(
              this.person.ResidencyType
            );
            this.person.Emirate = this._mapper.mapLookupItem(
              this.person.Emirate
            );
            this.person.PreferedLanguage = this._mapper.mapLookupItem(
              this.person.PreferedLanguage
            );
            this.lookups = this._mapper.mapLookups(response.Lookups);
            this.setFormValue(this.person);
          }
        });
      } else {
        this._service
          .GetAuthorityToRegister(this.token)
          .subscribe((response) => {
            if (response) {
              this.authority = Object.assign({
                ...response.Person,
                NameAr: null,
                NameEn: null,
              });
              this.authority.Owners = [];
              this.authority.LicenseIssuanceDate = null;
              this.authority.LicenseExpiryDate = null;
              if (this.authority.Latitude && this.authority.Longtuide) {
                this.authority.Location = {
                  address: null,
                  latitude: Number(this.authority.Latitude),
                  longitude: Number(this.authority.Longtuide),
                };
              }
              this.lookups = this._mapper.mapLookups(response.Lookups);
              this.setFormValue(this.authority);
            }
          });
      }
    }
  }

  register(): void {
    this.showError = false;
    if (this.form.valid) {
      if (this.isPerson) {
        this._service
          .Register(
            this._mapper.mapPersonData({
              ...this.form.getRawValue(),
              Token: this.token,
            })
          )
          .subscribe(
            (response) => {
              if(this.validateAccountNumber(response)){
                this.accountNo = response;
                this.registrationCompleted = true;
              }
              else{
                this.toaster.error(response);
              }
            },
            (error) => {
              this.displayError(error);
            }
          );
      } else {
        this._service
          .Register(
            this._mapper.mapAuthorityData({
              ...this.form.getRawValue(),
              Token: this.token,
            })
          )
          .subscribe(
            (response) => {
              if(this.validateAccountNumber(response)){
                this.accountNo = response;
                this.registrationCompleted = true;
              }
              else{
                this.toaster.error(response);
              }
            },
            (error) => {
              this.displayError(error);
            }
          );
      }
    } else {
      this.form.markAllAsTouched();
      this.focusOnError();
    }
  }

  login() {
    let url = environment.UAEPASSLoginURL + this.translateService.currentLang;
    url = url.replace(
      this.UAEPassRedirectUrlReplacable,
      `${environment.UAEPassDefaultRedirectURL}`
    );
    window.location.href = url;
  }

  setAuthorityOwnerValidation(isRequired: boolean) {
    this.requireOwners = isRequired;
  }

  validateAccountNumber(accountNumber:string): boolean {
    let dahses:number=0;
    for(let ch of accountNumber){
      if(ch=='-'){
        dahses++;
      }
    }
    return dahses==2;
  }
}
